module.exports = __webpack_public_path__ + "img/79200.ea72c524.jpg";